import { checkJsonTranslateProp } from '.';
import { TranslationContexts, TranslationsAction, store } from '../Redux';
import { stringInject } from '../utils';

function translationFunction(context: string, key: string, params?: any): string {
  const state = store.getState();
  const translations = (state.translationReducer as any)?.translations as any[];
  const { language } = state.languageReducer;

  const missingKeysCache = new Set(JSON.parse(sessionStorage.getItem('missingKeys') || '[]'));
  const requestKey = `${context}_${key}`;

  if (!key) {
    return key;
  }

  const [groupKey, entryKey] = key.replace(/\./, '-i18-').split('-i18-');

  if (!translations || !language || !context || !groupKey || !entryKey) {
    return key;
  }

  const contextTranslation = translations.find((translation) => translation.context === context && translation.culture === language);

  if (!contextTranslation) {
    return entryKey;
  }

  const value: string | null = checkJsonTranslateProp(contextTranslation.Groups, key);
  const group: Record<string, string> | null = checkJsonTranslateProp(contextTranslation.Groups, groupKey);

  const isValueAndGroupEntryMissing = value === null && !group?.[entryKey];

  if (context !== TranslationContexts.classificators && isValueAndGroupEntryMissing && !missingKeysCache.has(requestKey)) {
    missingKeysCache.add(requestKey);

    sessionStorage.setItem('missingKeys', JSON.stringify([...missingKeysCache]));

    TranslationsAction.getCreateTranslation(context, language, groupKey, entryKey);
  }

  return stringInject(value || key, params);
}

export const trc = (id: string): string => {
  return translationFunction(TranslationContexts.classificators, id);
};

export const trb = (id: string, params?: any): string => {
  return translationFunction(TranslationContexts.eBank, id, params);
};
